import React from "react";

const ButtonComponent = ({ buttonName, handleClick,disabled }) => {
  return (
    <>
      <div className="m-2">
        <button
          type="button"
          onClick={handleClick}
          disabled={disabled}
          className={`w-full font-semibold  ${!disabled ? "bg-yellow text-12151D" : "bg-ff4040 text-FEFFFF"} focus:ring-4 rounded-lg text-sm px-5 py-2.5 me-2 mb-2 focus:outline-none`}
        >
          {buttonName}
        </button>
      </div>
    </>
  );
};

export default ButtonComponent;
